import { Pipe, PipeTransform } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';

@Pipe({
  name: 'CGICCodeToFD',
  pure: true
})
export class CGICCodeToFDPipe implements PipeTransform {

  fieldDivisions: ServerModels.ENESS_REF_FieldDivisions[] = [];
  apiCall: Observable<ServerModels.ENESS_REF_FieldDivisions>;
  constructor(private _loginService: LoginService) {
  }
  
  transform(CGICCode: string): Observable<String> {
    return this._loginService.fieldDivisions$.pipe<String>(map((fda: ServerModels.ENESS_REF_FieldDivisions[]) => fda.find((fdv: ServerModels.ENESS_REF_FieldDivisions) => {
      if (fdv.ENESS_REF_NIBINCGICCodes) {
        return fdv.ENESS_REF_NIBINCGICCodes.OrganizationCode === CGICCode;
      }
      return false;
    }).FieldDivisionName));
  }
}
